import React from "react";
import { FiCheck, FiX } from "react-icons/fi";
import { Card, Table } from "reactstrap";

import classes from "@/styles/pricing/pricing.module.css";
import { pricing } from "@/utils/content";

type Props = {
  data: any;
};

const PlanFeatures = ({ data }: Props) => {
  const content = pricing.en;
  return (
    <>
      <section className="my-5" id="core-features-section">
        <h4 className="text-center fw-bold mb-4">{content.coreFeatures}</h4>
        <Card className="w-75 mx-auto">
          <Table className={classes.table} striped>
            <thead>
              <tr>
                <th>Features</th>
                {data?.map((p: any, i: number) => {
                  return (
                    <th className="text-center" key={i}>
                      {p.title}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {data[0].features.map((f: any, i: number) => {
                if (f.featureCategory === "CORE")
                  return (
                    <tr key={i}>
                      <td className="w-25">{f.featureName}</td>
                      {data.map((p: any, i: number) => {
                        const fea = p.features.find(
                          (ff: any) => ff.featureName === f.featureName
                        );
                        return (
                          <td key={i} className={`text-center ${classes.td}`}>
                            {fea.featureValue === "Yes" ? (
                              <FiCheck className={classes.yes} />
                            ) : fea.featureValue === "No" ? (
                              <FiX className={classes.no} />
                            ) : (
                              fea.featureValue
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
              })}
            </tbody>
          </Table>
        </Card>
      </section>
      <section className="my-5" id="advanced-features-section">
        <h4 className="text-center fw-bold mb-4">{content.advanceFeatures}</h4>
        <Card className="w-75 mx-auto">
          <Table className={classes.table} striped>
            <thead>
              <tr>
                <th>Features</th>
                {data.map((p: any, i: number) => {
                  return (
                    <th className="text-center" key={i}>
                      {p.title}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {data[0]?.features.map((f: any, i: number) => {
                if (f.featureCategory === "ADVANCED")
                  return (
                    <tr key={i}>
                      <td className="w-25">{f.featureName}</td>
                      {data.map((p: any, i: number) => {
                        const fea = p.features.find(
                          (ff: any) => ff.featureName === f.featureName
                        );
                        return (
                          <td key={i} className={`text-center ${classes.td}`}>
                            {fea.featureValue === "Yes" ? (
                              <FiCheck className={classes.yes} />
                            ) : fea.featureValue === "No" ? (
                              <FiX className={classes.no} />
                            ) : (
                              fea.featureValue
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
              })}
            </tbody>
          </Table>
        </Card>
      </section>
    </>
  );
};

export default PlanFeatures;
